import React from 'react'
import styles from './Toggle.module.css'

interface ToggleProps {
    checked: boolean
    onChange: (value: boolean) => void
    ariaLabel?: string
}

export const Toggle: React.FC<ToggleProps> = ({
    checked,
    onChange,
    ariaLabel,
}) => {
    return (
        <div className={styles.toggleContainer}>
            <label className={styles.switch}>
                <input
                    type="checkbox"
                    role="switch"
                    aria-label={ariaLabel}
                    onChange={(e) => onChange(e.target.checked)}
                    checked={checked}
                />
                <span className={styles.slider}></span>
            </label>
        </div>
    )
}
